// eslint-disable-next-line import/prefer-default-export
export const InitTransition = {
  length: 2,
  delay: 0.5,
};
